import React from 'react';
import {KTMScreen, ActionEvent, RenderEvent, renderScreen, TabSet, Tab, Layout, RecordTabs} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Display, Button, EmptyState} from 'ktm-ui';
import ProductRecordScreen from "../enroll/product/Record";
import ProductNewScreen from "../enroll/product/New";
import Edit_generalScreen from "../enroll/product/Edit_general";
import toastr from "toastr";

export default KTMScreen({name: "enroll.policy.billingteladoc"}, class extends React.Component<{ policy_id: string }> {

    state = {
        loading: true,
        editingTeladocDetails: false,
        editingTeladocAdvisors: false,
        teladoc: {
            enabled: false,
            waitingPeriod: 0,
            bank: {
                transitNo: "",
                bankNo: "",
                accountNo: ""
            }
        },
        selectedAdvisor1: null,
        selectedAdvisor2: null,
        selectedAdvisor3: null,
        search1: '',
        search2: '',
        search3: '',
        advisors1: [],
        advisors2: [],
        advisors3: [],
        advisor1Rate: null,
        advisor2Rate: null,
        advisor3Rate: null,
        originalTeladocDetails: null,
        originalAdvisors: null,
        originalAdvisorRates: null
    }

    constructor(props) {
        super(props);
        this.saveTeladocDetails = this.saveTeladocDetails.bind(this);
        this.saveTeladocAdvisors = this.saveTeladocAdvisors.bind(this);
        this.cancelEditTeladocDetails = this.cancelEditTeladocDetails.bind(this);
        this.cancelEditTeladocAdvisors = this.cancelEditTeladocAdvisors.bind(this);
    }

    componentDidMount() {
        this.startLoading();
    }

    async startLoading() {
        const policyId = this.props.policy_id;
        const responseDetails = await fetch(`/api/Teladoc/getdetails?policyId=${policyId}`);

        if (!responseDetails.ok) {
            console.error('Failed to load teladoc details');
            return;
        }

        // Load details
        const teladocDetails = await responseDetails.json();
        this.setState({
            teladoc: {
                enabled: teladocDetails.enabled,
                waitingPeriod: teladocDetails.waitingPeriod,
                bank: {
                    transitNo: teladocDetails.transitNo,
                    bankNo: teladocDetails.bankNo,
                    accountNo: teladocDetails.accountNo,
                }
            },
            originalTeladocDetails: {
                enabled: teladocDetails.enabled,
                waitingPeriod: teladocDetails.waitingPeriod,
                bank: {
                    transitNo: teladocDetails.transitNo,
                    bankNo: teladocDetails.bankNo,
                    accountNo: teladocDetails.accountNo,
                }
            }
        });

        // Load advisors
        const responseAdvisors = await fetch(`/api/Teladoc/getadvisors?policyId=${policyId}`);
        if (!responseAdvisors.ok) {
            console.error('Failed to load teladoc advisors');
            return;
        }

        const advisors = await responseAdvisors.json();

        this.setState({
            selectedAdvisor1: advisors.teladocAdvisor1 ? { id: advisors.teladocAdvisor1, name: advisors.teladocAdvisor1Name } : null,
            advisor1Rate: advisors.teladocAdvisor1Rate,
            selectedAdvisor2: advisors.teladocAdvisor2 ? { id: advisors.teladocAdvisor2, name: advisors.teladocAdvisor2Name } : null,
            advisor2Rate: advisors.teladocAdvisor2Rate,
            selectedAdvisor3: advisors.teladocAdvisor3 ? { id: advisors.teladocAdvisor3, name: advisors.teladocAdvisor3Name } : null,
            advisor3Rate: advisors.teladocAdvisor3Rate,
            loading: false, 
        });
    }
    
    handleSearch = async (searchTerm, advisorNumber) => {
        const response = await fetch(`/api/teladoc/searchadvisors?search=${searchTerm}`);
        const advisors = await response.json();

        this.setState({[`advisors${advisorNumber}`]: advisors});

        if (advisors.length === 1) {
            this.handleSelectAdvisor(advisors[0], advisorNumber);
        }
    }

    handleSelectAdvisor = (advisor, advisorNumber) => {
        this.setState({
            [`selectedAdvisor${advisorNumber}`]: advisor,
            [`search${advisorNumber}`]: advisor.name,
        });
    }
    
    startEditingTeladocDetails = () => {
        this.setState({
            editingTeladocDetails: true,
            originalTeladocDetails: {
                enabled: this.state.teladoc.enabled,
                waitingPeriod: this.state.teladoc.waitingPeriod,
                bank: {
                    transitNo: this.state.teladoc.bank.transitNo,
                    bankNo: this.state.teladoc.bank.bankNo,
                    accountNo: this.state.teladoc.bank.accountNo,
                }
            }
        });
    }

    startEditingTeladocAdvisors = () => {
        this.setState({
            editingTeladocAdvisors: true,
            originalAdvisors: {
                selectedAdvisor1: this.state.selectedAdvisor1,
                selectedAdvisor2: this.state.selectedAdvisor2,
                selectedAdvisor3: this.state.selectedAdvisor3,
            },
            originalAdvisorRates: {
                advisor1Rate: this.state.advisor1Rate,
                advisor2Rate: this.state.advisor2Rate,
                advisor3Rate: this.state.advisor3Rate,
            },
            search1: this.state.selectedAdvisor1 ? this.state.selectedAdvisor1.name : '',
            search2: this.state.selectedAdvisor2 ? this.state.selectedAdvisor2.name : '',
            search3: this.state.selectedAdvisor3 ? this.state.selectedAdvisor3.name : '',
        });
    }

    saveTeladocDetails = async () => {
        const { transitNo, bankNo, accountNo } = this.state.teladoc.bank;
        const isAnyBankFieldFilled = transitNo?.trim() || bankNo?.trim() || accountNo?.trim();
        const areAllBankFieldsFilled = transitNo?.trim() && bankNo?.trim() && accountNo?.trim();
        if (this.state.teladoc.enabled && isAnyBankFieldFilled && !areAllBankFieldsFilled) {
            toastr.error("Please enter the complete bank information", "Error");
            return;
        }

        const teladocDetails = {
            PolicyId: this.props.policy_id,
            Enabled: this.state.teladoc.enabled,
            WaitingPeriod: this.state.teladoc.waitingPeriod,
            BankNo: this.state.teladoc.bank.bankNo?.trim() || null,
            TransitNo: this.state.teladoc.bank.transitNo?.trim() || null,
            AccountNo: this.state.teladoc.bank.accountNo?.trim() || null,
        };

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(teladocDetails),
        };

        const note =
            (teladocDetails.Enabled !== undefined ? "Enabled: " + teladocDetails.Enabled + " " : "") +
            (teladocDetails.WaitingPeriod ? "WaitingPeriod: " + teladocDetails.WaitingPeriod + " " : "") +
            (teladocDetails.BankNo ? "BankNo: " + teladocDetails.BankNo + " " : "") +
            (teladocDetails.TransitNo ? "TransitNo: " + teladocDetails.TransitNo + " " : "") +
            (teladocDetails.AccountNo ? "AccountNo: " + teladocDetails.AccountNo : "");

        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note:  note,
            Action: "Policy Edit Teladoc Details",
            PolicyId: this.props.policy_id,
            }),
         };

        try {
            const response = await fetch("/api/Teladoc/updatedetails", requestOptions);
            if (!response.ok) {
                throw new Error("Failed to save Teladoc details");
            }
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
            toastr.success("Teladoc details updated successfully");
            this.setState({
                editingTeladocDetails: false,
                originalTeladocDetails: null
            });
        } catch (error) {
            console.error("Error saving Teladoc details:", error);
            toastr.error("Failed to save Teladoc details. Please try again.", "Error");
        }
    }

    cancelEditTeladocDetails = () => {
        if (this.state.originalTeladocDetails) {
            this.setState({
                editingTeladocDetails: false,
                teladoc: {
                    enabled: this.state.originalTeladocDetails.enabled,
                    waitingPeriod: this.state.originalTeladocDetails.waitingPeriod,
                    bank: {
                        transitNo: this.state.originalTeladocDetails.bank.transitNo,
                        bankNo: this.state.originalTeladocDetails.bank.bankNo,
                        accountNo: this.state.originalTeladocDetails.bank.accountNo,
                    }
                },
                originalTeladocDetails: null
            });
        } else {
            this.setState({
                editingTeladocDetails: false
            });
        }
    }

    cancelEditTeladocAdvisors = () => {
        if (this.state.originalAdvisors && this.state.originalAdvisorRates) {
            this.setState({
                editingTeladocAdvisors: false,
                selectedAdvisor1: this.state.originalAdvisors.selectedAdvisor1,
                selectedAdvisor2: this.state.originalAdvisors.selectedAdvisor2,
                selectedAdvisor3: this.state.originalAdvisors.selectedAdvisor3,
                advisor1Rate: this.state.originalAdvisorRates.advisor1Rate,
                advisor2Rate: this.state.originalAdvisorRates.advisor2Rate,
                advisor3Rate: this.state.originalAdvisorRates.advisor3Rate,
                originalAdvisors: null,
                originalAdvisorRates: null,
                search1: '',
                search2: '',
                search3: '',
                advisors1: [],
                advisors2: [],
                advisors3: [],
            });
        } else {
            this.setState({
                editingTeladocAdvisors: false,
                search1: '',
                search2: '',
                search3: '',
                advisors1: [],
                advisors2: [],
                advisors3: [],
            });
        }
    }
    
    async saveTeladocAdvisors() {
        if (this.state.selectedAdvisor1 && this.state.selectedAdvisor2 && this.state.selectedAdvisor1.id === this.state.selectedAdvisor2.id ||
            this.state.selectedAdvisor1 && this.state.selectedAdvisor3 && this.state.selectedAdvisor1.id === this.state.selectedAdvisor3.id ||
            this.state.selectedAdvisor2 && this.state.selectedAdvisor3 && this.state.selectedAdvisor2.id === this.state.selectedAdvisor3.id) {
            toastr.error("Advisor already assigned", "Error");
            return;
        }

        const advisor1Rate = parseFloat(this.state.advisor1Rate) || 0;
        const advisor2Rate = parseFloat(this.state.advisor2Rate) || 0;
        const advisor3Rate = parseFloat(this.state.advisor3Rate) || 0;
        const totalRate = advisor1Rate + advisor2Rate + advisor3Rate;

        if (totalRate > 3) {
            toastr.error("The total of all advisor rates must not exceed $3.", "Error");
            return;
        }

        const teladocAdvisors = {
            Id: this.props.policy_id,
            TeladocAdvisor1: this.state.selectedAdvisor1 ? this.state.selectedAdvisor1.id : null,
            TeladocAdvisor2: this.state.selectedAdvisor2 ? this.state.selectedAdvisor2.id : null,
            TeladocAdvisor3: this.state.selectedAdvisor3 ? this.state.selectedAdvisor3.id : null,
            TeladocAdvisor1Rate: parseFloat(this.state.advisor1Rate) || 0,
            TeladocAdvisor2Rate: parseFloat(this.state.advisor2Rate) || 0,
            TeladocAdvisor3Rate: parseFloat(this.state.advisor3Rate) || 0,
        };

        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(teladocAdvisors),
        };

        const note =
            (this.state.selectedAdvisor1 ? "Advisor1: " + this.state.selectedAdvisor1.name + " " : "") +
            (this.state.selectedAdvisor2 ? "Advisor2: " + this.state.selectedAdvisor2.name + " " : "") +
            (this.state.selectedAdvisor3 ? "Advisor3: " + this.state.selectedAdvisor3.name + " " : "") +
            (parseFloat(this.state.advisor1Rate) ? "Advisor1Rate: " + parseFloat(this.state.advisor1Rate) + " " : "") +
            (parseFloat(this.state.advisor2Rate) ? "Advisor2Rate: " + parseFloat(this.state.advisor2Rate) + " " : "") +
            (parseFloat(this.state.advisor3Rate) ? "Advisor3Rate: " + parseFloat(this.state.advisor3Rate) : "");
        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note:  note,
            Action: "Policy Edit Teladoc Advisors",
            PolicyId: this.props.policy_id,
            }),
         };

        await fetch("/api/teladoc/setadvisors", requestOptions).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        })

        this.setState({editingTeladocAdvisors: false});
    }

    removeAdvisor = (advisorNumber) => {
        if (this.state.teladoc.enabled && advisorNumber === 1) {
            toastr.error("At least one advisor must be assigned when Teladoc is enabled.", "Error");
            return;
        }

        this.setState({
            [`selectedAdvisor${advisorNumber}`]: null,
            [`advisor${advisorNumber}Rate`]: null,
            [`search${advisorNumber}`]: '',
            [`advisors${advisorNumber}`]: [],
        });
    }

    handleRateChange = (advisorNumber, rate) => {
        this.setState({ [`advisor${advisorNumber}Rate`]: rate });
    }

    render() {
        return renderScreen(this);
    }

    async start({screen}: ActionEvent) {
        screen.title = "Billing";
    }

    contents() {

        if (this.state.loading) {
            return <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    width: '65px',
                    height: '65px',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 50001
                }}>
                <svg className="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle className="spinner-path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33"
                            cy="33" r="30"></circle>
                </svg>
            </div>
        }

        return (<div className={"RT-Layout"}>
            <div className={"RT-Layout__body"}>
                <div className={"RT-Row"}>
                    <div className={"RT-Column"} style={{flexBasis: 0, flexGrow: 1}}>
                        <div className={"RT-Section"}>
                            <div className={"RT-Section__header"}>
                                <div className={"RT-Section__title"}>
                                    Teladoc Details
                                </div>
                                <div className={"RT-Section__actions"}>
                                    {this.state.editingTeladocDetails ? (

                                        <div style={{display: 'inline-block'}}>
                                            <button className="RT-Link" onClick={this.cancelEditTeladocDetails}>Cancel
                                            </button>
                                            <button className="RT-Link" onClick={this.saveTeladocDetails}>Save</button>
                                        </div>
                                    ) : (
                                        <a href="#" className="RT-Link"
                                           onClick={() => this.setState({editingTeladocDetails: true})}>Edit</a>
                                    )}
                                </div>
                            </div>
                            <div className={"RT-Line"}>
                                <div className={"RT-Line__content RT-Line__content--space-evenly"}>
                                    <div className={"RT-Line__item"}>
                                        <div className={"RT-Static-Field"}>
                                            <label className={"RT-Static-Field__label"}>
                                                Teladoc Enabled
                                            </label>
                                            <div className={"RT-Static-Field__content"}>
                                                {this.state.editingTeladocDetails ? (
                                                    <select className={"RT-TextBox__select"}
                                                            value={this.state.teladoc.enabled ? "true" : "false"}
                                                            onChange={(e) => this.setState({
                                                                teladoc: {
                                                                    ...this.state.teladoc,
                                                                    enabled: e.target.value === "true"
                                                                }
                                                            })}>
                                                        <option value="true">Enabled</option>
                                                        <option value="false">Disabled</option>
                                                    </select>
                                                ) : (
                                                    this.state.teladoc.enabled ? "Enabled" : "Disabled"
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"RT-Line__item"}>
                                        <div className={"RT-Static-Field"}>
                                            <label className={"RT-Static-Field__label"}>
                                                Waiting Period
                                            </label>
                                            <div className={"RT-Static-Field__content"}>
                                                {this.state.editingTeladocDetails ? (
                                                    <select className={"RT-TextBox__select"}
                                                            value={this.state.teladoc.waitingPeriod}
                                                            onChange={(e) => this.setState({
                                                                teladoc: {
                                                                    ...this.state.teladoc,
                                                                    waitingPeriod: parseInt(e.target.value, 10)
                                                                }
                                                            })}>
                                                        {[...Array(13)].map((_, i) => <option key={i}
                                                                                              value={i}>{i}</option>)}
                                                    </select>
                                                ) : (
                                                    `${this.state.teladoc.waitingPeriod !== undefined ? this.state.teladoc.waitingPeriod : 0} Months`
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"RT-Line"}>
                                <div className={"RT-Line__content RT-Line__content--space-evenly"}>
                                    <div className={"RT-Line__item"}>
                                        <div className={"RT-Static-Field"}>
                                            <label className={"RT-Static-Field__label"}>
                                                Bank Transit No.
                                            </label>
                                            <div className={"RT-Static-Field__content"}>
                                                {this.state.editingTeladocDetails ? (
                                                    <input type="text" className={"RT-TextBox__input"}
                                                           value={this.state.teladoc.bank.transitNo}
                                                           onChange={(e) => this.setState({
                                                               teladoc: {
                                                                   ...this.state.teladoc,
                                                                   bank: {
                                                                       ...this.state.teladoc.bank,
                                                                       transitNo: e.target.value
                                                                   }
                                                               }
                                                           })}/>
                                                ) : (
                                                    this.state.teladoc.bank.transitNo
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"RT-Line__item"}>
                                        <div className={"RT-Static-Field"}>
                                            <label className={"RT-Static-Field__label"}>
                                                Bank No.
                                            </label>
                                            <div className={"RT-Static-Field__content"}>
                                                {this.state.editingTeladocDetails ? (
                                                    <input type="text" className={"RT-TextBox__input"}
                                                           value={this.state.teladoc.bank.bankNo}
                                                           onChange={(e) => this.setState({
                                                               teladoc: {
                                                                   ...this.state.teladoc,
                                                                   bank: {
                                                                       ...this.state.teladoc.bank,
                                                                       bankNo: e.target.value
                                                                   }
                                                               }
                                                           })}/>
                                                ) : (
                                                    this.state.teladoc.bank.bankNo
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"RT-Line__item"}>
                                        <div className={"RT-Static-Field"}>
                                            <label className={"RT-Static-Field__label"}>
                                                Bank Account No.
                                            </label>
                                            <div className={"RT-Static-Field__content"}>
                                                {this.state.editingTeladocDetails ? (
                                                    <input type="text" className={"RT-TextBox__input"}
                                                           value={this.state.teladoc.bank.accountNo}
                                                           onChange={(e) => this.setState({
                                                               teladoc: {
                                                                   ...this.state.teladoc,
                                                                   bank: {
                                                                       ...this.state.teladoc.bank,
                                                                       accountNo: e.target.value
                                                                   }
                                                               }
                                                           })}/>
                                                ) : (
                                                    this.state.teladoc.bank.accountNo
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"RT-Column"} style={{flexBasis: 0, flexGrow: 1}}>
                        <div className={"RT-Section"}>
                            <div className={"RT-Section__header"}>
                                <div className={"RT-Section__title"}>
                                    Teladoc Advisors
                                </div>
                                <div className={"RT-Section__actions"}>
                                    {this.state.editingTeladocAdvisors ? (
                                        <div style={{display: 'inline-block'}}>
                                            <button className="RT-Link"
                                                    onClick={this.cancelEditTeladocAdvisors}>Cancel
                                            </button>
                                            <button className="RT-Link" onClick={this.saveTeladocAdvisors}>Save</button>
                                        </div>
                                    ) : (
                                        <a href="#" className="RT-Link"
                                           onClick={this.startEditingTeladocAdvisors}>Edit</a>
                                    )}
                                </div>
                            </div>

                            {/*Advisor 1*/}
                            <div className={"RT-Line"}>
                                <div className={"RT-Line__content RT-Line__content--space-evenly"}>
                                    <div className={"RT-Line__item"}>
                                        <div className={"RT-Static-Field"}>
                                            <label className={"RT-Static-Field__label"}>
                                                Advisor 1 (Primary)
                                            </label>
                                            <div className={"RT-Static-Field__content"}>
                                                {this.state.editingTeladocAdvisors ? (
                                                    <>
                                                        <input className={"RT-TextBox__input"}
                                                               type="text"
                                                               value={this.state.search1}
                                                               onChange={e => this.setState({search1: e.target.value})}
                                                               onBlur={() => this.handleSearch(this.state.search1, 1)}
                                                               onKeyPress={e => {
                                                                   if (e.key === 'Enter') {
                                                                       this.handleSearch(this.state.search1, 1);
                                                                   }
                                                               }}
                                                        />
                                                        {this.state.advisors1.length > 0 && (
                                                            <select className="RT-TextBox__select custom-dropdown"
                                                                    onChange={e => this.handleSelectAdvisor(this.state.advisors1[e.target.selectedIndex - 1], 1)}>
                                                                <option className="dropdown-header" disabled selected>Advisor Name - Advisor ID</option>
                                                                {this.state.advisors1.map((advisor, index) => (
                                                                    <option key={index} value={index + 1}>
                                                                        {advisor.name} - {advisor.advisorId}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        )}
                                                    </>
                                                ) : (
                                                    <p>{this.state.selectedAdvisor1 ? this.state.selectedAdvisor1.name : 'No advisor selected'}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.selectedAdvisor1 && (
                                        <div className={"RT-Line__item"}>
                                            <div className={"RT-Static-Field"}>
                                                <label className={"RT-Static-Field__label"}>
                                                    Advisor 1 Rate
                                                </label>
                                                <div className={"RT-Static-Field__content"}>
                                                    {this.state.editingTeladocAdvisors ? (
                                                        <select
                                                            className={"RT-TextBox__select"}
                                                            value={this.state.advisor1Rate || '0'}
                                                            onChange={e => this.handleRateChange(1, e.target.value)}
                                                        >
                                                            <option value="0">$0</option>
                                                            <option value="1">$1</option>
                                                            <option value="2">$2</option>
                                                            <option value="3">$3</option>
                                                        </select>
                                                    ) : (
                                                        <p>{this.state.advisor1Rate ? `$${this.state.advisor1Rate}` : 'No rate set'}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {/*<div className={"RT-Line__item"}>*/}
                                {/*    {this.state.editingTeladocAdvisors && (*/}
                                {/*        <button className="RT-Link"*/}
                                {/*                onClick={() => this.removeAdvisor(1)}>Remove</button>*/}
                                {/*    )}*/}
                                {/*</div>*/}
                            </div>

                            {/*Advisor 2*/}
                            {/*{this.state.selectedAdvisor1 && (*/}
                            {/*    <div className={"RT-Line"}>*/}
                            {/*        <div className={"RT-Line__content RT-Line__content--space-evenly"}>*/}
                            {/*            <div className={"RT-Line__item"}>*/}
                            {/*                <div className={"RT-Static-Field"}>*/}
                            {/*                    <label className={"RT-Static-Field__label"}>*/}
                            {/*                        Advisor 2*/}
                            {/*                    </label>*/}
                            {/*                    <div className={"RT-Static-Field__content"}>*/}
                            {/*                        {this.state.editingTeladocAdvisors ? (*/}
                            {/*                            <>*/}
                            {/*                                <input className={"RT-TextBox__input"}*/}
                            {/*                                       type="text"*/}
                            {/*                                       value={this.state.search2}*/}
                            {/*                                       onChange={e => this.setState({search2: e.target.value})}*/}
                            {/*                                       onBlur={() => this.handleSearch(this.state.search2, 2)}*/}
                            {/*                                       onKeyPress={e => {*/}
                            {/*                                           if (e.key === 'Enter') {*/}
                            {/*                                               this.handleSearch(this.state.search2, 2);*/}
                            {/*                                           }*/}
                            {/*                                       }}*/}
                            {/*                                />*/}
                            {/*                                {this.state.advisors2.length > 0 && (*/}
                            {/*                                    <select className={"RT-TextBox__select"}*/}
                            {/*                                            onChange={e => this.handleSelectAdvisor(this.state.advisors2[e.target.selectedIndex - 1], 2)}>*/}
                            {/*                                        <option>Select an advisor</option>*/}
                            {/*                                        {this.state.advisors2.map((advisor, index) => (*/}
                            {/*                                            <option key={index}*/}
                            {/*                                                    value={index + 1}>{advisor.name}</option>*/}
                            {/*                                        ))}*/}
                            {/*                                    </select>*/}
                            {/*                                )}*/}
                            {/*                            </>*/}
                            {/*                        ) : (*/}
                            {/*                            <p>{this.state.selectedAdvisor2 ? this.state.selectedAdvisor2.name : 'No advisor selected'}</p>*/}
                            {/*                        )}*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*            {this.state.selectedAdvisor2 && (*/}
                            {/*                <div className={"RT-Line__item"}>*/}
                            {/*                    <div className={"RT-Static-Field"}>*/}
                            {/*                        <label className={"RT-Static-Field__label"}>*/}
                            {/*                            Advisor 2 Rate*/}
                            {/*                        </label>*/}
                            {/*                        <div className={"RT-Static-Field__content"}>*/}
                            {/*                            {this.state.editingTeladocAdvisors ? (*/}
                            {/*                                <select*/}
                            {/*                                    className={"RT-TextBox__select"}*/}
                            {/*                                    value={this.state.advisor2Rate || '0'}*/}
                            {/*                                    onChange={e => this.handleRateChange(2, e.target.value)}*/}
                            {/*                                >*/}
                            {/*                                    <option value="0">$0</option>*/}
                            {/*                                    <option value="1">$1</option>*/}
                            {/*                                    <option value="2">$2</option>*/}
                            {/*                                    <option value="3">$3</option>*/}
                            {/*                                </select>*/}
                            {/*                            ) : (*/}
                            {/*                                <p>{this.state.advisor2Rate ? `$${this.state.advisor2Rate}` : 'No rate set'}</p>*/}
                            {/*                            )}*/}
                            {/*                        </div>*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            )}*/}
                            {/*        </div>*/}
                            {/*        <div className={"RT-Line__item"}>*/}
                            {/*            {this.state.editingTeladocAdvisors && (*/}
                            {/*                <button className="RT-Link"*/}
                            {/*                        onClick={() => this.removeAdvisor(2)}>Remove</button>*/}
                            {/*            )}*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*)}*/}

                            {/*Advisor 3*/}
                            {/*{this.state.selectedAdvisor2 && (*/}
                            {/*    <div className={"RT-Line"}>*/}
                            {/*        <div className={"RT-Line__content RT-Line__content--space-evenly"}>*/}
                            {/*            <div className={"RT-Line__item"}>*/}
                            {/*                <div className={"RT-Static-Field"}>*/}
                            {/*                    <label className={"RT-Static-Field__label"}>*/}
                            {/*                        Advisor 3*/}
                            {/*                    </label>*/}
                            {/*                    <div className={"RT-Static-Field__content"}>*/}
                            {/*                        {this.state.editingTeladocAdvisors ? (*/}
                            {/*                            <>*/}
                            {/*                                <input className={"RT-TextBox__input"}*/}
                            {/*                                       type="text"*/}
                            {/*                                       value={this.state.search3}*/}
                            {/*                                       onChange={e => this.setState({search3: e.target.value})}*/}
                            {/*                                       onBlur={() => this.handleSearch(this.state.search3, 3)}*/}
                            {/*                                       onKeyPress={e => {*/}
                            {/*                                           if (e.key === 'Enter') {*/}
                            {/*                                               this.handleSearch(this.state.search3, 3);*/}
                            {/*                                           }*/}
                            {/*                                       }}*/}
                            {/*                                />*/}
                            {/*                                {this.state.advisors3.length > 0 && (*/}
                            {/*                                    <select className={"RT-TextBox__select"}*/}
                            {/*                                            onChange={e => this.handleSelectAdvisor(this.state.advisors3[e.target.selectedIndex - 1], 3)}>*/}
                            {/*                                        <option>Select an advisor</option>*/}
                            {/*                                        {this.state.advisors3.map((advisor, index) => (*/}
                            {/*                                            <option key={index}*/}
                            {/*                                                    value={index + 1}>{advisor.name}</option>*/}
                            {/*                                        ))}*/}
                            {/*                                    </select>*/}
                            {/*                                )}*/}
                            {/*                            </>*/}
                            {/*                        ) : (*/}
                            {/*                            <p>{this.state.selectedAdvisor3 ? this.state.selectedAdvisor3.name : 'No advisor selected'}</p>*/}
                            {/*                        )}*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*            {this.state.selectedAdvisor3 && (*/}
                            {/*                <div className={"RT-Line__item"}>*/}
                            {/*                    <div className={"RT-Static-Field"}>*/}
                            {/*                        <label className={"RT-Static-Field__label"}>*/}
                            {/*                            Advisor 3 Rate*/}
                            {/*                        </label>*/}
                            {/*                        <div className={"RT-Static-Field__content"}>*/}
                            {/*                            {this.state.editingTeladocAdvisors ? (*/}
                            {/*                                <select*/}
                            {/*                                    className={"RT-TextBox__select"}*/}
                            {/*                                    value={this.state.advisor3Rate || '0'}*/}
                            {/*                                    onChange={e => this.handleRateChange(3, e.target.value)}*/}
                            {/*                                >*/}
                            {/*                                    <option value="0">$0</option>*/}
                            {/*                                    <option value="1">$1</option>*/}
                            {/*                                    <option value="2">$2</option>*/}
                            {/*                                    <option value="3">$3</option>*/}
                            {/*                                </select>*/}
                            {/*                            ) : (*/}
                            {/*                                <p>{this.state.advisor3Rate ? `$${this.state.advisor3Rate}` : 'No rate set'}</p>*/}
                            {/*                            )}*/}
                            {/*                        </div>*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            )}*/}
                            {/*        </div>*/}
                            {/*        <div className={"RT-Line__item"}>*/}
                            {/*            {this.state.editingTeladocAdvisors && (*/}
                            {/*                <button className="RT-Link"*/}
                            {/*                        onClick={() => this.removeAdvisor(3)}>Remove</button>*/}
                            {/*            )}*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*)}*/}

                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }

    main({draw}: RenderEvent) {
        return <Layout>
            {draw(this.contents)}
        </Layout>
    }
});
